<template>
  <Layout
    title="For Britain as a whole, improving local shops is the top regeneration priority."
    blurb="And when asked to rate how well their area is doing on the things they think are important, most people are positive."
    instruction="Type in your postcode - or choose your constituency from the list - to see what people in your area think."
  />
</template>

<script>
// @ is an alias to /src
import Layout from "@/components/Layout.vue";

export default {
  name: "MostUrgent",
  components: {
    Layout
  },
  // Helps pass down to grandchildren
  provide: {
    sitearea: "mosturgent"
  }
};
</script>
